import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuth: false,
    jid: null,
    currentUser: null,
    userPic: "",
    loginType: "",
    notificationFlag: false,
    isToggled: false,
    adminMeLoaded: false,
    /** Selected city scope for city admins (`type: admin`). */
    adminActiveCityId: null,
  },
  reducers: {
    toggle: (state) => {
      state.isToggled = !state.isToggled;
    },
    setAuth: (state, action) => {
      state.isAuth = action.payload;
    },
    setNotificaiton: (state, action) => {
      state.notificationFlag = action.payload;
    },
    setJid: (state, action) => {
      state.jid = action.payload;
    },
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setLogout: (state) => {
      state.currentUser = null;
      state.jid = null;
      state.isAuth = false;
      state.userPic = "";
      state.loginType = "";
      state.adminMeLoaded = false;
      state.adminActiveCityId = null;
    },
    setAdminMeLoaded: (state, action) => {
      state.adminMeLoaded = Boolean(action.payload);
    },
    setAdminActiveCityId: (state, action) => {
      state.adminActiveCityId = action.payload || null;
    },
    setLogin: (state, action) => {
      state.currentUser = action.payload.currentUser;
      state.jid = action.payload.jid;
      state.isAuth = action.payload.isAuth;
      state.loginType = action.payload.loginType;
      state.adminMeLoaded = false;
      state.adminActiveCityId = null;
    },
    setUserPic: (state, action) => {
      state.userPic = action.payload;
    },
  },
});

export const {
  setAuth,
  setJid,
  setUser,
  setLogout,
  setLogin,
  setUserPic,
  setNotificaiton,
  setAdminMeLoaded,
  setAdminActiveCityId,
  toggle,
} = authSlice.actions;

export default authSlice.reducer;